import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import AuthenticationContainer from '../containers/AuthenticationProvider/AuthenticationProvider.container'
import PartnershipCertificateDialogContainer from '../containers/PartnershipCertificateDialog/PartnershipCertificateDialog.container'

/**
 * The PartnershipCertificate's page.
 */
const PartnershipCertificate = () => {
  return (
    <AuthenticationContainer>
      <BrandLayout>
        <PartnershipCertificateDialogContainer />
      </BrandLayout>
    </AuthenticationContainer>
  )
}

export default PartnershipCertificate
